export const LOAD_SETTINGS = 'loadSettings'
